import http from './httpService';
import config from './../config.json';

export const getAllPlaces = (params, {cancelToken}) => {
	return http.get(config.api_place, {cancelToken, params});
}

export const getPlacesArchive = (params, {cancelToken}) => {
	return http.get(`${config.api_place}/archive`, {cancelToken, params});
}

export const getPlaceById = (_id) => {
	return http.get(`${config.api_place}/${_id}`);
}

export const getPlaceInfoById = (_id, {cancelToken}) => {
	return http.get(`${config.api_place}/info/${_id}`, {cancelToken});
}

export const createPlace = (place) => {
	return http.post(`${config.api_place}`, place);
}

export const updatePlace = (_id, place) => {
	return http.patch(`${config.api_place}/${_id}`, place);
}

export const deletePlaceById = (_id) => {
	return http.delete(`${config.api_place}/${_id}`);
}